import React, { useEffect, useMemo, useRef, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import SectionA from "./components/SectionA/SectionA";
import SectionB from "./components/SectionB/SectionB";
import SectionC from "./components/SectionC/SectionC";
import { useLazyGetSelfEvalutionIdByAppIdQuery } from "../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { useReturnApplicationToCaseOfficerByPeerReviewerMutation, useSavePeerReviewerEvaluationDetailsMutation, useLazyGetPeerReviewEvaluationDetailsByIdQuer, useLazyGetPeerReviewEvaluationDetailsByIdQuery, useLazyGetMinimumCriteriaForServiceByApplicationIdQuery } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import ToastService from "../../services/toastService/ToastService";
import { decryptAESID } from "../../utils/Encryption";
import { useSaveSelfEvaluationFinalApproverDetailsMutation, useUpdateApplicationStatusOnPeerReviewerReturnMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";
import SwalAlert from "../../services/swalService/SwalService";
// import { useFinalApproverContext } from "./FinalApproverConext";
import { useFinalApproverServiceContext } from "./FinalApproverServiceConext";


const FinalApproverServiceForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [peerReviewerComment, setPeerReviewerComment] = useState("")
  const { state, dispatch } = useFinalApproverServiceContext();
  const { confirm } = SwalAlert()
  const sectionCCount = state.sectionCCount;
  const [isRetrun, setIsReturn] = useState(false);
  const [approvalComment, setApprovalComment] = useState("")
  const [tempId, setTempId] = useState(null);
  const routeMap = {
    10: "CertificateGroupingWIthRatingFinalReview",
    11: "CertificateGroupingWIthoutRatingFinalReview",
  };

  const [getSelfEvaluationId, { isLoading: selfEvaluationIdIsLoading, isSuccess: selfEvaluationIdIsSuccess, data: selfEvaluationIdData, },] = useLazyGetSelfEvalutionIdByAppIdQuery();
  const [returnToCaseOfficer, { isLoading: returnToCaseOfficeLoading, isSuccess: returnToCaseOfficerSuccess, data: returnToCaseOfficerData, },] = useReturnApplicationToCaseOfficerByPeerReviewerMutation();
  const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
  const [updateApplicationStatusOnPeerReviewerReturn, { isLoading: updateStatusOnReturnLoading, isSuccess: updateStatusOnReturnLoadingSuccess, data: updateStatusOnReturnLoadingData }] = useUpdateApplicationStatusOnPeerReviewerReturnMutation();

  const [saveSelfEvaluationFinalApproverDetails, { isLoading: saveSelfEvaluationFinalApproverDetailsLoading, isSuccess: saveSelfEvaluationFinalApproverDetailsSuccess, data: saveSelfEvaluationFinalApproverDetailsData }] = useSaveSelfEvaluationFinalApproverDetailsMutation();
  const [getMinimumCriteriaForService, { data: minimumCriteria, isLoading: minimumCriteriaLoading }] = useLazyGetMinimumCriteriaForServiceByApplicationIdQuery();

  useEffect(() => {
    const editID = decryptAESID(id, false);
    if (editID > 0) {
      getSelfEvaluationId(editID);
      getPeerReviewEvaluationDetailsById(editID)
      getMinimumCriteriaForService(editID)
    }
  }, [id]);

  useEffect(() => {
    if (!selfEvaluationIdIsLoading && selfEvaluationIdIsSuccess) {
      setTempId(selfEvaluationIdData?.templateId);
      ["A", "B",].forEach((section) => {
        dispatch({
          type: "SET_SELF_EVALUATION_ID",
          section,
          selfEvaluationId: selfEvaluationIdData?.selfEvaluationId || null,
        });
      });
    }
  }, [selfEvaluationIdIsSuccess, selfEvaluationIdData, selfEvaluationIdIsLoading]);

  useEffect(() => {
    if (!returnToCaseOfficeLoading && returnToCaseOfficerSuccess && returnToCaseOfficerData) {
      if (!returnToCaseOfficerData.hasError) {
        ToastService.success("Application Returned to Case Officer");
        handleBack();
      } else {
        ToastService.error(returnToCaseOfficerData.errorMessage);
      }
    }
  }, [returnToCaseOfficeLoading, returnToCaseOfficerSuccess, returnToCaseOfficerData]);

  useEffect(() => {
    if (!minimumCriteriaLoading && minimumCriteria) {
      const value = Number(minimumCriteria?.minimumCriteria) || 0;
      dispatch({ type: "SET_SECTION_B_MIN_CRITERIA", value });
    }
  }, [minimumCriteriaLoading, minimumCriteria]);

  useEffect(() => {
    if (!saveSelfEvaluationFinalApproverDetailsLoading && saveSelfEvaluationFinalApproverDetailsSuccess && saveSelfEvaluationFinalApproverDetailsData) {
      if (!saveSelfEvaluationFinalApproverDetailsData.hasError) {
        !isRetrun && ToastService.success("Details updated Successfully.");
      } else {
        ToastService.error(saveSelfEvaluationFinalApproverDetailsData.errorMessage);
      }
      setIsReturn(false)
    }
  }, [saveSelfEvaluationFinalApproverDetailsLoading, saveSelfEvaluationFinalApproverDetailsSuccess, saveSelfEvaluationFinalApproverDetailsData]);

  useEffect(() => {
    if (!getPeerReviewEvaluationDetailsByIdLoading && getPeerReviewEvaluationDetailsByIdSuccess && getPeerReviewEvaluationDetailsByIdData) {
      setPeerReviewerComment(getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment)
      setApprovalComment(getPeerReviewEvaluationDetailsByIdData?.finalApproverComment)
    }
  }, [getPeerReviewEvaluationDetailsByIdLoading, getPeerReviewEvaluationDetailsByIdSuccess, getPeerReviewEvaluationDetailsByIdData]);


  const handleBack = () => {
    navigate("/viewApplicationTaskList")
  }

  const handleSave = () => {
    let { sections } = state;
    let sGBPProductInformationId = decryptAESID(id, false);
    const payload = {
      SGBPProductInformationId: sGBPProductInformationId || null,
      FinalApproverComment: approvalComment,
      SaveFinalApproverInternalCommentListRequest: [],
    };

    Object.entries(sections).forEach(([sectionKey, sectionValue]) => {
      Object.entries(sectionValue.requirements || {}).forEach(
        ([requirementId, requirementData]) => {

          const obj = {
            SGBPProductInformationId: sGBPProductInformationId,
            SelfEvaluationRequirementId: requirementData?.selfEvalRequirementId,
            FinalApproverInternalComment: requirementData?.peerReviewerComments,
          };
          if (
            obj.SGBPProductInformationId != null && obj.SelfEvaluationRequirementId != null && obj.FinalApproverInternalComment != null) {
            payload.SaveFinalApproverInternalCommentListRequest.push(obj);
          }
        }
      );
    });
    if (payload) {
      saveSelfEvaluationFinalApproverDetails(payload)
    }
  }

  const handleNext = async () => {
    debugger
    setIsReturn(true);
    await handleSave();
    const route = routeMap[tempId];
    // navigate(`/CertificateGroupingApprove/${id}`);
    navigate(route ? `/${route}/${id}` : `/CertificateGroupingApprove/${id}`);
  };

  const handleReturn = () => {
    confirm('Return?', 'Are you sure you want to return?', 'Return', 'Cancel').then((confirmed) => {
      if (confirmed) {
        handleReturnApplication();
      }
    });
  };

  const handleReturnApplication = () => {
    setIsReturn(true);
    let req = {}
    req.sGBPProductInformationId = decryptAESID(id);
    req.peerReviewerComment = peerReviewerComment
    req.FinalApproverComment = approvalComment
    if (req) {
      handleSave();
      returnToCaseOfficer(req)
      updateApplicationStatusOnPeerReviewerReturn({ SGBPProductInformationId: decryptAESID(id) });
    }
  };

  const handleApprovalChange = (e) => {
    setApprovalComment(e.target.value);
  }

  return (
    <div className="self-evaluation-page">
      <SectionA />
      <SectionB />
      {/* <SectionC /> */}
      {/* <div className="section-card">
        <div className="commant-box">
          <label>Peer Reviewer Comment</label>
          <textarea
            disabled
            className="mt-2"
            value={peerReviewerComment}
            maxLength={200}
          />
        </div>
        <div className="commant-box">
          <label>Approver Reviewer Comment</label>
          <textarea
            // disabled
            className="mt-2"
            value={approvalComment}
            onChange={handleApprovalChange}
            maxLength={200}
          />

        </div>
      </div> */}

      <div className="form-actions">
        <Buttons buttonText="Back" buttonTypeClassName="black-btn btn outline-btn " onClick={handleBack} />
        <Buttons buttonText="Save" buttonTypeClassName="submit-btn btn outline-btn" onClick={handleSave} isLoading={!isRetrun && saveSelfEvaluationFinalApproverDetailsLoading} isDisable={saveSelfEvaluationFinalApproverDetailsLoading} />
        <Buttons buttonText="Return" buttonTypeClassName="reject  btn" onClick={handleReturn} isLoading={returnToCaseOfficeLoading || updateStatusOnReturnLoading} isDisable={returnToCaseOfficeLoading || updateStatusOnReturnLoading} />
        <Buttons buttonText="Next" buttonTypeClassName="submit-btn btn outline-btn" onClick={handleNext} />
      </div>
    </div>
  );
};

export default FinalApproverServiceForm;
